/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota", "Nedelja"], e = ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], t = "Godine", n = "Godina", o = "Mesec", s = "Sedmica", r = "Dana", c = "Dan", d = "Danas", l = "Nema događaja", i = "Celi dan", m = "Obriši", b = "Kreiraj događaj", k = "dddd D MMMM YYYY", u = {
  weekDays: a,
  months: e,
  years: t,
  year: n,
  month: o,
  week: s,
  days: r,
  day: c,
  today: d,
  noEvent: l,
  allDay: i,
  deleteEvent: m,
  createEvent: b,
  dateFormat: k
};
export {
  i as allDay,
  b as createEvent,
  k as dateFormat,
  c as day,
  r as days,
  u as default,
  m as deleteEvent,
  o as month,
  e as months,
  l as noEvent,
  d as today,
  s as week,
  a as weekDays,
  n as year,
  t as years
};
